<template>
    <div class="Jur-Cadastro-Principal">
        <PageTitle icon="fa fa-group" main="Cadastro"
            sub="Cadastro -> Escritório / Advogados" />
        <div class="Jur-Cadastro-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Escritórios" active><ClienteFornecedor /></b-tab>
                    <b-tab title="Advogados"><Advogados /></b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import ClienteFornecedor from '../juridico/ClienteFornecedor'
import Advogados from '../juridico/Advogados'


export default {
    name: 'JuridicoPrincipal',    
    components: { PageTitle, ClienteFornecedor,Advogados }
    
}
</script>

<style>

</style>






